import defaultSource from "./defaultSource";

export default (function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(defaultSource);



//////////////////
// WEBPACK FOOTER
// ./~/d3-random/src/irwinHall.js
// module id = 154
// module chunks = 0